import { useQuery, UseQueryOptions } from '@tanstack/react-query';

import { sharedABQueryKeys } from '@p/ab/shared/utilities/query-keys';

import { ICategoryBySource } from '@t/api/audience/data-points/source.model';
import { IResult } from '@t/api/common/operation-results/success-result.model';

import { dataDictionaryService } from 'services/data-dictionary.service';

export const createDataPointsQuery = (
  source?: string,
  category?: string
): UseQueryOptions<IResult<ICategoryBySource[]>, unknown, ICategoryBySource[]> => {
  return {
    queryFn: () => {
      return dataDictionaryService.getDataPoints(source, category);
    },
    queryKey: sharedABQueryKeys.dataPoints(source, category),
    select: (result: IResult<ICategoryBySource[]> | undefined) => {
      return result?.dataContainer ?? [];
    },
  };
};

export const useFetchDataPoints = (source?: string, category?: string) => {
  return useQuery(createDataPointsQuery(source, category));
};
